import { Globe } from "lucide-react";
import { LANGS, getLang, setLangGlobal } from "@/lib/i18n";
import { api } from "@/lib/api";
import { Select, SelectTrigger, SelectContent, SelectItem } from "@/components/ui/select";

export async function changeLang(code, loggedIn) {
  setLangGlobal(code);
  if (loggedIn) {
    try { await api.post("/auth/lang", { lang: code }); } catch (e) { console.warn("lang save failed", e); }
  }
  window.location.reload();
}

export function LanguageSwitcher({ dark = false, loggedIn = false }) {
  const change = (code) => changeLang(code, loggedIn);
  const cur = LANGS.find((l) => l.code === getLang());
  return (
    <Select value={getLang()} onValueChange={change}>
      <SelectTrigger className={`h-9 w-[92px] gap-1 ${dark ? "bg-transparent border-white/20 text-white" : "bg-white"}`} data-testid="language-switcher">
        <Globe className="h-4 w-4 shrink-0" /><span className="text-xs font-semibold">{cur?.flag}</span>
      </SelectTrigger>
      <SelectContent>
        {LANGS.map((l) => <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>{l.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
